<template>
  <b-card
    title="Tüm Kayıtlı Abone Listesi"
    class="border border-secondary"
  >

    <div class="form-label-group">
      <b-input-group>
        <div class="sag mb-2">
          <span class="alert alert-danger mr-1  ">Toplam Kayıtlı Abone:</span> <b class="mr-3">2</b>
        </div>
        <b-form-input
          class="mb-2"
          type="text"
          placeholder="Tabloda Ara"
        />

      </b-input-group></div>
    <div>
      <b-table
        :items="items"
        :fields="fields"
        striped
        responsive
      >

        <template #row-details="row">
          <b-card>
            <b-row class="mb-2">
              <b-col
                md="4"
                class="mb-1"
              >
                {{ row.item.full_name }}
              </b-col>

            </b-row>
            <div>
              <!-- button trigger -->
              <div class="demo-inline-spacing">
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  v-b-modal.modal-primary
                  variant="primary"
                >
                  Detaylı İncele
                </b-button>

                <b-button
                  v-ripple.400="'rgba(0, 207, 232, 0.15)'"
                  v-b-modal.modal-info
                  variant="info"
                >
                  Grafik Görünüm
                </b-button>
                <b-button
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  v-b-modal.modal-dark
                  variant="dark"
                >
                  Kompanzasyon Verileri
                </b-button>
                <b-button
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  v-b-modal.modal-dark
                  variant="warning"
                >
                  Reaktif Bedelleri
                </b-button>
                <b-button
                  v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                  variant="danger"
                >
                  <feather-icon icon="Trash2Icon" />
                  Aboneyi Sil
                </b-button>
              </div>

              <!-- modal -->
              <b-modal
                id="modal-primary"
                ok-only
                ok-title="Accept"
                modal-class="modal-primary"
                centered
                title="Primary Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-seconday"
                ok-only
                ok-variant="secondary"
                ok-title="Accept"
                modal-class="modal-secondary"
                centered
                title="Secondary Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-success"
                ok-only
                ok-variant="success"
                ok-title="Accept"
                modal-class="modal-success"
                centered
                title="Success Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-danger"
                ok-only
                ok-variant="danger"
                ok-title="Accept"
                modal-class="modal-danger"
                centered
                title="Danger Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-info"
                ok-only
                ok-variant="info"
                ok-title="Accept"
                modal-class="modal-info"
                centered
                title="Info Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-warning"
                ok-only
                ok-variant="warning"
                ok-title="Accept"
                modal-class="modal-warning"
                centered
                title="Warning Modal"
              >
                <b-card-text>
                  Biscuit chocolate cake gummies. Lollipop I love macaroon bear claw caramels. I love marshmallow tiramisu I love
                  fruitcake I love gummi bears. Carrot cake topping liquorice. Pudding caramels liquorice sweet I love. Donut powder
                  cupcake ice cream tootsie roll jelly.
                </b-card-text>
              </b-modal>

              <b-modal
                id="modal-dark"
                ok-only
                ok-variant="dark"
                ok-title="Accept"
                modal-class="modal-dark"
                centered
                title="Güç Analizörü "
              >
                <div class="demo-inline-spacing">
                  <b-card>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        small
                        type="grow"
                      />
                      L1
                    </b-button>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        variant="success"
                        small
                        type="grow"
                      />
                      L2
                    </b-button>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        small
                        type="grow"
                      />
                      L3
                    </b-button>
                  </b-card>
                </div>
                <div class="demo-inline-spacing">
                  <b-card>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        small
                        type="grow"
                      />
                      CAP
                    </b-button>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        variant="success"
                        small
                        type="grow"
                      />
                      Normal
                    </b-button>
                    <b-button
                      variant="primarsdsy"
                    >
                      <b-spinner
                        small
                        type="grow"
                      />
                      IND
                    </b-button>
                  </b-card>
                </div>
              </b-modal>
            </div>
          </b-card>
        </template>

        <template #cell(avatar)="data">
          <b-avatar :src="data.value" />
        </template>

        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
        <template #cell(islem)="row">
          <b-form-checkbox
            v-model="row.detailsShowing"
            plain
            class="vs-checkbox-con"
            @change="row.toggleDetails"
          >
            <span class="vs-checkbox">
              <span class="vs-checkbox--check">
                <i class="vs-icon feather arrow-down" />
              </span>
            </span>
          </b-form-checkbox>
        </template>
      </b-table>
    </div><br>
    <div class="text-right">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="flat-primary"
      >
        <feather-icon
          icon="ShuffleIcon"
        />
        Seçilenleri Karşılaştır
      </b-button>
      <b-button
        v-ripple.400="'rgba(186, 191, 199, 0.15)'"
        variant="flat-info"
      >
        <feather-icon
          icon="DownloadIcon"
        />
        Aboneleri İndir
      </b-button>
    </div>
  </b-card>

</template>

<script>
import {
  BTable, BFormCheckbox, BButton, BCard, BRow, BCol, BBadge, BFormInput, BModal, BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BRow,
    BCol,
    BBadge,
    BFormInput,
    BModal,
    BSpinner,

  },
  data() {
    return {
      fields: ['islem', 'id', 'Abone_No', 'Abone_Adı', 'sektor', 'ilk_index', 'Son_index', 'Kullanım_Miktarı', 'Kullanım_Tutarı', 'Toplam_TEB', { key: 'status', label: 'Status' }],
      items: [
        {
          id: 1,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/10-small.png'),
          Abone_No: 'Deneme',
          Abone_Adı: 'Deneme',
          sektor: 'Deneme',
          ilk_index: 'Deneme',
          Son_index: 'Deneme',
          Kullanım_Miktarı: 'Deneme',
          Kullanım_Tutarı: 'Deneme',
          Toplam_TEB: 'Deneme',

          status: 2,
        },
        {
          id: 2,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/10-small.png'),
          Abone_No: 'Deneme',
          Abone_Adı: 'Deneme',
          sektor: 'Deneme',
          ilk_index: 'Deneme',
          Son_index: 'Deneme',
          Kullanım_Miktarı: 'Deneme',
          Kullanım_Tutarı: 'Deneme',
          Toplam_TEB: 'Deneme',

          status: 2,
        },

      ],
      status: [{
        1: 'Current', 2: 'Aktif', 3: 'Aktif Değil', 4: 'Veri Alınmıyor', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
}
</script>
<style>
.sag{
  float: right;
}
</style>
